// extracted by mini-css-extract-plugin
export default {"main__block__ticket__style":"TicketParticipation_main__block__ticket__style__70ltQ","cursor":"TicketParticipation_cursor__1LHeb"};